export type UserProfile = {
  name: string | null;
  email: string;
  image: string | null;
  conversionCount: number;
};

export async function fetchUserProfile(): Promise<UserProfile | null> {
  try {
    const response = await fetch("/api/user/profile", { credentials: "include" });
    if (!response.ok) return null;
    return (await response.json()) as UserProfile;
  } catch {
    return null;
  }
}

export async function recordUserConversion(): Promise<number> {
  try {
    const response = await fetch("/api/user/conversions", {
      method: "POST",
      credentials: "include",
    });
    if (!response.ok) return 0;
    const json = (await response.json()) as { conversionCount?: number };
    return json.conversionCount ?? 0;
  } catch {
    return 0;
  }
}
